import { faFileDownload, faFileUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Authorization from '../../../Authentication/Authorization'
import DialogContext from '../../../Authentication/DialogContext'
import DataTable from '../../../components/DataTable'
import { EditDialogProps } from '../../../components/EditDialog'
import ProtectedButton from '../../../components/ProtectedButton'
import Loading from '../../../layout/Loading'
import SsoProxyService from '../../../service/SsoProxyService'

const SSOIDProviderConfiguration = (props: any) => {
  const { t } = useTranslation()
  const { configurationStatus, setConfigurationStatus } = props
  const [idpConfig, setIdpConfig] = useState({} as any)
  const [loading, setLoading] = useState(true)
  const { editDialogPropsSetter } = useContext(DialogContext)

  useEffect(() => {
    async function loadData() {
      const idpConfig = await SsoProxyService.getTargetIdPInfo()
      setIdpConfig(idpConfig)
    }
    loadData().finally(() => setLoading(false))
  }, [])

  const columns = useMemo(() => {
    return [
      {
        text: 'label',
        dataField: 'label',
        classes: 'font-weight-bolder',
        sort: true,
      },
      {
        text: 'value',
        dataField: 'value',
        sort: true,
      },
    ]
  }, [])

  const data = getData()

  return (
    <Loading isLoading={loading}>
      <DataTable keyField='label' data={data} columns={columns} headerClasses='d-none' searchable={false} />
      <div className='text-right pr-1 ml-nfc-1'>
        <ProtectedButton variant='primary' className='ml-auto my-auto' onClick={importIdPMetadata} permissions={Authorization.settings.ssoProxy.edit}>
          <FontAwesomeIcon icon={faFileUpload} />
          <span className='ml-1 my-auto'>{t('ssoProxy.importIdPMetadata')}</span>
        </ProtectedButton>
        {configurationStatus.targetIdPMetadataAvailable === true && (
          <ProtectedButton variant='primary' className='ml-auto my-auto' onClick={exportIdPMetadata} permissions={Authorization.settings.ssoProxy.edit}>
            <FontAwesomeIcon icon={faFileDownload} />
            <span className='ml-1 my-auto'>{t('ssoProxy.exportIdPMetadata')}</span>
          </ProtectedButton>
        )}
      </div>
    </Loading>
  )

  function getData() {
    if (idpConfig.issuer === undefined) {
      return []
    }
    const logonServices: any[] = idpConfig.logonServices?.map((entry: any) => {
      return {
        label: t('ssoProxy.ssoEndpoint') + ' ' + entry.binding,
        value: entry.location,
      }
    })
    const logoutServices: any[] = idpConfig?.logoutServices?.map((entry: any) => {
      return {
        label: t('ssoProxy.singleLogoutEndpoint') + ' ' + entry.binding,
        value: entry.location,
      }
    })
    return [
      {
        label: t('ssoProxy.idpName'),
        value: idpConfig.issuer,
      },
      ...(logonServices !== undefined ? logonServices : []),
      ...(logoutServices !== undefined ? logoutServices : []),
    ]
  }

  function importIdPMetadata() {
    const props: EditDialogProps = {
      show: true,
      header: t('ssoProxy.importIdPMetadata'),
      onSubmit: SsoProxyService.uploadIdPMetadata,
      onSubmitExtraArgs: [t, setIdpConfig, setConfigurationStatus],
      labelGridSize: 5,
      submitText: t('import'),
      data: [
        {
          id: 'idPMetadata',
          type: 'file',
          label: t('ssoProxy.idPMetadataFile'),
        },
      ],
    }

    editDialogPropsSetter(props)
  }

  function exportIdPMetadata() {
    SsoProxyService.downloadGatewayIdPMetadata()
  }
}

export default SSOIDProviderConfiguration
